import PermissionButton from '../../permissions/PermissionButton';
import React, { useState } from 'react';
import {
  Button,
  Space,
  Select,
  message,
  Row,
  Col,
  Typography,
} from 'antd';
import { ArrowRightOutlined, ShopOutlined } from '@ant-design/icons';
import { useFetchAllEntrepots } from '../../hooks/entrepotHooks';
import { useCreateTransfert } from '../../hooks/transfertHooks';

const { Text } = Typography;

const TransfertForm = ({ onTransfertCreated, onCancel }) => {
  const { entrepots, loading: ldg } = useFetchAllEntrepots();
  const { create } = useCreateTransfert();
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedDest, setSelectedDest] = useState(null);

  const handleCreate = async () => {
    try {
      if (!selectedSource) {
        message.error('Veuillez sélectionner un entrepôt source');
        return;
      }
      if (!selectedDest) {
        message.error('Veuillez sélectionner un entrepôt destination');
        return;
      }
      if (selectedSource.code_ent === selectedDest.code_ent) {
        message.error('L\'entrepôt source et destination doivent être différents');
        return;
      }
      const res = await create({
        CODE_ENT_SRC: selectedSource.code_ent,
        CODE_ENT_DEST: selectedDest.code_ent,
        DATE_TRF: new Date(),
      });
      message.success(`Transfert créé: ${res.REF_TRF || res.id}`);
      if (onTransfertCreated) {
        onTransfertCreated(res.id);
      }
    } catch (e) {
      message.error(e.message || 'Erreur création');
    }
  };

  const DepotPanel = ({ label, selected, placeholder, onSelect, excludeCode }) => (
    <div
      style={{
        padding: '16px',
        background: selected ? '#f6ffed' : '#fafafa',
        border: `1px solid ${selected ? '#b7eb8f' : '#e8e8e8'}`,
        borderRadius: 8,
        height: '100%',
        transition: 'all 0.3s',
      }}
    >
      <Text strong style={{ display: 'block', marginBottom: 12, fontSize: 15 }}>
        <ShopOutlined /> {label}
      </Text>
      <Select
        placeholder={placeholder}
        value={selected?.code_ent}
        onChange={onSelect}
        style={{ width: '100%' }}
        loading={ldg}
        showSearch
        allowClear
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        options={entrepots
          .filter(e => e.code_ent !== excludeCode)
          .map(e => ({ value: e.code_ent, label: `${e.code_ent} - ${e.name}` }))}
      />
      <div style={{ marginTop: 12, minHeight: 44 }}>
        {selected ? (
          <>
            <div style={{ fontWeight: 600, fontSize: 16 }}>{selected.name}</div>
            <Text type="secondary">Code: {selected.code_ent}</Text>
          </>
        ) : (
          <Text type="secondary">Aucun entrepôt sélectionné</Text>
        )}
      </div>
    </div>
  );

  return (
    <div style={{ display: 'grid', gap: 24 }}>
      <Row gutter={16} align="middle">
        <Col span={11}>
          <DepotPanel
            label="Entrepôt source (De)"
            selected={selectedSource}
            placeholder="Sélectionner entrepôt source"
            excludeCode={selectedDest?.code_ent}
            onSelect={(value) => {
              const ent = entrepots.find(e => e.code_ent === value);
              setSelectedSource(ent || null);
            }}
          />
        </Col>
        <Col span={2} style={{ textAlign: 'center' }}>
          <ArrowRightOutlined
            style={{
              fontSize: 28,
              color: selectedSource && selectedDest ? '#52c41a' : '#bfbfbf',
              transition: 'color 0.3s',
            }}
          />
        </Col>
        <Col span={11}>
          <DepotPanel
            label="Entrepôt destination (Vers)"
            selected={selectedDest}
            placeholder="Sélectionner entrepôt destination"
            excludeCode={selectedSource?.code_ent}
            onSelect={(value) => {
              const ent = entrepots.find(e => e.code_ent === value);
              setSelectedDest(ent || null);
            }}
          />
        </Col>
      </Row>
      <Space style={{ justifyContent: 'flex-end', width: '100%' }}>
        {onCancel && (
          <Button onClick={onCancel}>
            Annuler
          </Button>
        )}
        <PermissionButton permissionModule="transfers" permissionAction="create" type="primary" onClick={handleCreate} disabled={!selectedSource || !selectedDest}>
          Créer Transfert
        </PermissionButton>
      </Space>
    </div>
  );
};

export default TransfertForm;
















